import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

// ...props will override defaults
const ButtonTooltip = (props) => {
  return (
    <ReactTooltip
      anchorId="placeholder"
      className="react-tooltip"
      place="bottom"
      effect="solid"
      border={false}
      clickable
      multiline
      // eslint-disable-next-line react/no-unstable-nested-components -- TODO: find better way to represent this
      content={<div className="tooltip-text">Place holder text</div>}
      // eslint-disable-next-line react/jsx-props-no-spreading -- need props spreading to override defaults
      {...props}
      style={{ position: 'fixed' }}
    />
  );
};

export default ButtonTooltip;
